// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".loading-spinner{width:3rem;height:3rem}\n", "",{"version":3,"sources":["/app/src/component/specific/profile/profileCardDesign/profileCardDesign.scss"],"names":[],"mappings":"AACA,iBACE,UAAW,CACX,WAAY","file":"profileCardDesign.scss","sourcesContent":["/* loading style */\n.loading-spinner {\n  width: 3rem;\n  height: 3rem;\n}\n"]}]);
// Exports
module.exports = exports;
